publications:
  #
  - authors: Fumimaro Suzuki, Keisuke Okumura
    month: 10
    title: Map-Distribution Mixture-of-Experts for Multi-Agent Pathfinding
    year: 2026
    kind: preprint
    pages: 1–20
    image: moe
    book: arXiv preprint
    paperUrl: https://arxiv.org/abs/2610.25991
  #
  - authors: Rishabh Jain, Akmaral Moldagalieva, Lorenzo Magnino, Michael Amir, Keisuke Okumura, Ajay Shankar, Wolfgang Hönig, Amanda Prorok
    month: 10
    title: |
      GAMBIT: Learning to Plan Continuous Multi-Robot Trajectories
    year: 2026
    kind: preprint
    pages: 1–9
    image: gambit
    book: arXiv preprint
    paperUrl: https://arxiv.org/abs/2610.06290v1
  #
  - authors: Keisuke Okumura
    month: 9
    title: Solving Multi-Agent Sokoban via LaCAM
    year: 2026
    kind: preprint
    pages: 1–13
    image: sokoban
    book: arXiv preprint
    paperUrl: https://arxiv.org/abs/2609.39889
    projectPage: https://kei18.github.io/multi-agent-sokoban/
  #
  - abbr: T-RO
    authors: Yuhao Zhang, Keisuke Okumura, Ajay Shankar, Amanda Prorok
    github: https://github.com/proroklab/d4orm
    image: denoising
    month: 10
    others: IF(25-26)=11.6
    paperUrl: https://arxiv.org/abs/2609.35651
    title: Denoising Multi-Robot Trajectories
    youtube: https://www.youtube.com/watch?v=sK6mr42aXe8
    doi: https://doi.org/10.1109/TRO.2026.3742231
    year: 2026
    pages: 1-20
    kind: journal
  #
  - abbr: CoRL
    authors: Ryusei Matsumoto, Mei Kinjo, Yoko Sasaki, Keisuke Okumura
    month: 11
    title: Learning Coordinated Visuomotor Box-Pushing from Solo Demonstrations
    year: 2026
    kind: reviewedProceeding
    pages: 1–11
    image: box-pushing
    others:
      en: |
        acceptance rate: 687/2094=33%, in press
      ja: |
        採択率: 687/2094=33%, in press
    paperUrl: https://arxiv.org/abs/2610.05677
    youtube: https://www.youtube.com/watch?v=J9KfPI-hJX4
    #
  - authors: Takuro Kato, Keisuke Okumura
    month: 5
    title: Conveyor Parcel Routing with Order-Contiguous Arrivals
    year: 2026
    kind: preprint
    pages: 1–10
    image: conveyor
    book: arXiv preprint
    paperUrl: https://arxiv.org/abs/2605.13035
  - authors: Takahiro Suzuki, Yuma Tamura, Keisuke Okumura
    month: 5
    title: Distance-Constrained Unlabeled Multi-Agent Pathfinding
    year: 2026
    kind: preprint
    pages: 1–15
    image: iumapf
    book: arXiv preprint
    paperUrl: https://arxiv.org/abs/2605.11503
    #
  - abbr: SoCS
    authors: Tomoki Arita, Keisuke Okumura
    image: lllg
    month: 8
    title: Lifelong LaCAM with Local Guidance for Lifelong MAPF
    year: 2026
    kind: reviewedProceeding
    pages: 2–10
    github: https://github.com/allegorywrite/lllg
    doi: https://doi.org/10.1609/socs.v19i1.43067
    paperUrl: https://arxiv.org/abs/2605.16855
    others:
      en: |
        acceptance rate: 32/79=44% <br/>
        <span class="text-danger">The SoCS 2026 Best Student Paper Award</span>
      ja: |
        採択率: 32/79=44% <br/>
        <span class="text-danger">The SoCS 2026 Best Student Paper Award</span>
    #
  - abbr: SoCS
    authors: Yu Kumagai, Keisuke Okumura
    image: tapf
    month: 8
    title: Alternating Target–Path Planning for Scalable Multi-Agent Coordination
    year: 2026
    kind: reviewedProceeding
    github: https://github.com/Ukuma012/ir-tapf
    pages: 112–120
    paperUrl: https://arxiv.org/abs/2605.07744
    doi: https://doi.org/10.1609/socs.v19i1.43079
    others:
      en: "acceptance rate: 32/79=44%"
      ja: "採択率: 32/79=44%"
    #
  - abbr: IJCAI
    authors: Hiroki Nagai, Keisuke Okumura
    image: mawpf
    month: 8
    title: |
      From Gridworlds to Warehouses: Adapting Lightweight One-shot Multi-Agent Pathfinding for AGVs
    year: 2026
    github: https://github.com/hirokiNagai-39/mawpf
    pages: 306–313
    others:
      en: "acceptance rate: 953/5233=18%"
      ja: "採択率: 953/5233=18%"
    kind: reviewedProceeding
    paperUrl: https://arxiv.org/abs/2605.15799
    doi: https://doi.org/10.24963/ijcai.2026/35
    #
  - authors: Keisuke Okumura, Guang Yang, Zhan Gao, Heedo Woo, Amanda Prorok
    book: npj Robotics
    selected: true
    month: 3
    paperUrl: https://www.nature.com/articles/s44182-026-00083-2
    doi: https://doi.org/10.1038/s44182-026-00083-2
    title: Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers
    year: 2026
    kind: journal
    pages: 1-15
    image: agile-mapf
    github: https://github.com/proroklab/agile-mapf
    projectPage: https://proroklab.github.io/agile-mapf/
    youtube: https://www.youtube.com/watch?v=41kPW6JwXtY
    others: |
      Nature Portfolio. Featured in <a href="https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty">IEEE Spectrum Video Friday</a> (2026), <a href="https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml">Fantastico</a> (2025), and <a href="https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025">BBC Click</a> (2025). Presented at ICAPS-26 Previously Published Papers track.
      <br/>
      <span class="text-danger">Featured on the journal homepage as a hero image</span>
    #
  - abbr: ICAPS
    authors: Takahiro Suzuki, Keisuke Okumura
    image: cumapf
    month: 6
    title: "Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent
      Pathfinding
      "
    year: 2026
    github: https://github.com/su3taka/CUMAPF-PULL
    paperUrl: https://arxiv.org/abs/2510.19567
    pages: 323–331
    kind: reviewedProceeding
    doi: https://doi.org/10.1609/icaps.v36i1.42842
    others:
      en: "acceptance rate: 90/~400=23%"
      ja: "採択率: 90/~400=23%"
  - abbr: ICAPS
    authors: Akmaral Moldagalieva, Keisuke Okumura, Amanda Prorok, Wolfgang Hönig
    image: db-lacam
    month: 6
    title: "db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with
      Discontinuity-Bounded Search and Lightweight MAPF

      "
    year: 2026
    paperUrl: https://arxiv.org/abs/2512.06796
    pages: 738–746
    doi: https://doi.org/10.1609/icaps.v36i1.42894
    others:
      en: "acceptance rate: 90/~400=23%"
      ja: "採択率: 90/~400=23%"
    kind: reviewedProceeding
    github: https://github.com/IMRCLab/db-lacam
    youtube: https://www.youtube.com/watch?v=K7xUFpH7a48
    #
  - abbr: ICLR
    authors: Rishabh Jain, Keisuke Okumura, Michael Amir, Pietro Lio, Amanda Prorok
    image: hmagat
    month: 4
    title: "Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding"
    year: 2026
    pages: 1-10
    github: https://github.com/proroklab/hmagat
    paperUrl: https://arxiv.org/abs/2602.06733
    others:
      en: "acceptance rate: x/~19000=28%"
      ja: "採択率: x/~19000=28%"
    kind: reviewedProceeding
    #
  - abbr: AAAI
    authors: Tomoki Arita, Keisuke Okumura
    image: lg
    month: 3
    title: "Local Guidance for Configuration-Based Multi-Agent Pathfinding

      "
    year: 2026
    github: https://github.com/allegorywrite/lg_lacam
    paperUrl: https://arxiv.org/abs/2510.19072
    pages: 29296-29304
    others:
      en: "acceptance rate: 4167/23680=17%

        "
      ja: "採択率: 4167/23680=17%

        "
    kind: reviewedProceeding
    doi: https://doi.org/10.1609/aaai.v40i35.40169
  - abbr: AAAI
    selected: true
    authors: Rishabh Jain, Keisuke Okumura, Michael Amir, Amanda Prorok
    image: lagat
    month: 3
    title: "Graph Attention-Guided Search for Dense Multi-Agent Pathfinding

      "
    year: 2026
    pages: 29504-29512
    github: https://github.com/proroklab/lagat
    paperUrl: https://arxiv.org/abs/2510.17382
    others:
      en: "acceptance rate: 4167/23680=17%

        "
      ja: "採択率: 4167/23680=17%

        "
    kind: reviewedProceeding
    doi: https://doi.org/10.1609/aaai.v40i35.40192
  - abbr: IROS
    authors: Yuhao Zhang, Keisuke Okumura, Heedo Woo, Ajay Shankar, Amanda Prorok
    image: d4orm
    doi: https://doi.org/10.1109/IROS60139.2025.11246029
    month: 10
    paperUrl: https://arxiv.org/abs/2503.12204
    title: "D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations

      "
    year: 2025
    pages: 14118-14123
    youtube: https://www.youtube.com/watch?v=WuFuecpZQSY
    github: https://github.com/proroklab/d4orm
    others:
      en: "acceptance rate: 1991/4306=46%

        "
      ja: "採択率: 1991/4306=46%

        "
    kind: reviewedProceeding
  - abbr: CoRL
    authors: Michael Amir, Guang Yang, Zhan Gao, Keisuke Okumura, Heedo Woo, Amanda
      Prorok
    image: recode
    month: 9
    youtube: https://www.youtube.com/watch?v=SgCE0TFOz2c
    paperUrl: https://arxiv.org/abs/2507.19151
    title: "ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent
      Coordination

      "
    year: 2025
    pages: 1598--1614
    others:
      en: "acceptance rate: 264/738=36%

        "
      ja: "採択率: 264/738=36%

        "
    kind: reviewedProceeding
  - abbr: SoCS
    authors: Keisuke Okumura, Hiroki Nagai
    image: dense-pibt
    month: 7
    paperUrl: https://arxiv.org/abs/2505.12623
    github: https://github.com/HirokiNagai-39/pibt-tiebreaking
    title: "Lightweight and Effective Preference Construction in PIBT for Large-Scale
      Multi-Agent Pathfinding

      "
    year: 2025
    pages: 110–117
    others:
      en: "acceptance rate: 22/59=37%

        "
      ja: "採択率: 22/59=37%

        "
    doi: https://doi.org/10.1609/socs.v18i1.35982
    kind: reviewedProceeding
  - abbr: AAMAS
    authors: Keisuke Okumura
    image: lacam3
    month: 5
    paperUrl: https://arxiv.org/abs/2308.04292
    github: https://github.com/Kei18/lacam3/
    projectPage: https://kei18.github.io/lacam3/
    speakerdeck: https://speakerdeck.com/kei18/engineering-lacam-star-towards-real-time-large-scale-and-near-optimal-multi-agent-pathfinding
    title: "Engineering LaCAM∗: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent
      Pathfinding

      "
    year: 2024
    pages: 1501–1509
    others:
      en: "Acceptance Rate: 229/883=25.9%

        "
      ja: "採択率: 229/883=25.9%

        "
    doi: https://dl.acm.org/doi/10.5555/3635637.3663010
    kind: reviewedProceeding
  - abbr: IJCAI
    authors: Keisuke Okumura
    github: https://github.com/Kei18/lacam2/
    image: lacam2
    month: 8
    paperUrl: https://arxiv.org/abs/2305.03632
    projectPage: https://kei18.github.io/lacam2
    title: Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding
    year: 2023
    pages: 243-251
    doi: https://doi.org/10.24963/ijcai.2023/28
    speakerdeck: https://speakerdeck.com/kei18/improving-lacam-for-scalable-eventually-optimal-multi-agent-pathfinding
    others:
      en: "Acceptance Rate: x/4566=15%

        "
      ja: "採択率: x/4556=15%

        "
    kind: reviewedProceeding
  - abbr: IJCAI
    authors: Keisuke Okumura, Xavier Défago
    github: https://github.com/Kei18/sssp/
    image: mrmp
    month: 8
    doi: https://doi.org/10.24963/ijcai.2023/29
    paperUrl: https://arxiv.org/abs/2203.00315
    projectPage: https://kei18.github.io/sssp
    title: Quick Multi-Robot Motion Planning by Combining Sampling and Search
    youtube: https://www.youtube.com/watch?v=ZMjrQCKS6Fw
    year: 2023
    others:
      en: "Acceptance Rate: x/4566=15%

        "
      ja: "採択率: x/4556=15%

        "
    pages: 252-261
    speakerdeck: https://speakerdeck.com/kei18/quick-multi-robot-motion-planning-by-combining-sampling-and-search
    kind: reviewedProceeding
  - abbr: AAAI
    selected: true
    authors: Keisuke Okumura
    image: lacam
    doi: https://doi.org/10.1609/aaai.v37i10.26377
    paperUrl: https://arxiv.org/abs/2211.13432
    month: 2
    others:
      en: "Acceptance Rate: 1721/8777=19.6%

        "
      ja: "採択率: 1721/8777=19.6%

        "
    title: "LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding

      "
    year: 2023
    projectPage: https://kei18.github.io/lacam
    speakerdeck: https://speakerdeck.com/kei18/lacam-search-based-algorithm-for-quick-multi-agent-pathfinding
    github: https://github.com/Kei18/lacam/
    pages: 11655-11662
    kind: reviewedProceeding
  - abbr: AAAI
    authors: Keisuke Okumura, Sebastien Tixeuil
    doi: https://doi.org/10.1609/aaai.v37i10.26376
    paperUrl: https://arxiv.org/abs/2211.13908
    month: 2
    others:
      en: "Acceptance Rate: 1721/8777=19.6%

        "
      ja: "採択率: 1721/8777=19.6%

        "
    title: Fault-Tolerant Offline Multi-Agent Path Planning
    image: mappcf
    year: 2023
    github: https://github.com/Kei18/mappcf/
    speakerdeck: https://speakerdeck.com/kei18/fault-tolerant-offline-multi-agent-path-planning
    projectPage: https://kei18.github.io/mappcf
    pages: 11647-11654
    kind: reviewedProceeding
  - abbr: IJCAI
    authors: Keisuke Okumura, François Bonnet, Yasumasa Tamura, Xavier Défago
    doi: https://doi.org/10.24963/ijcai.2022/645
    github: https://github.com/Kei18/otimapp/
    image: otimapp
    month: 7
    others:
      en: "Acceptance Rate: 679/4535=14.9%

        "
      ja: "採択率: 679/4535=14.9%

        "
    paperUrl: https://arxiv.org/abs/2105.07132
    projectPage: https://kei18.github.io/otimapp
    speakerdeck: https://speakerdeck.com/kei18/offline-time-independent-multi-agent-path-planning
    title: Offline Time-Independent Multi-Agent Path Planning
    youtube: https://youtu.be/-p59f3epO1M
    year: 2022
    pages: 4649-4656
    kind: reviewedProceeding
  - abbr: ICAPS
    pages: 270-278
    authors: Keisuke Okumura, Xavier Défago
    github: https://github.com/Kei18/tswap/
    image: unlabeled
    month: 6
    doi: https://doi.org/10.1609/icaps.v32i1.19810
    others:
      en: 'Acceptance Rate: 85/277=30.6%<br/>

        <span class="text-danger">The ICAPS 2022 Best Student Paper Award</span>

        '
      ja: '採択率: 85/277=30.6%<br/>

        <span class="text-danger">The ICAPS 2022 Best Student Paper Award</span>

        '
    paperUrl: https://ojs.aaai.org/index.php/ICAPS/article/view/19810
    projectPage: https://kei18.github.io/tswap/
    speakerdeck: https://speakerdeck.com/kei18/solving-simultaneous-target-assignment-and-path-planning-efficiently-with-time-independent-execution
    title: Solving Simultaneous Target Assignment and Path Planning Efficiently with
      Time-Independent Execution
    youtube: https://youtu.be/NkU8r2u8-1c
    year: 2022
    kind: reviewedProceeding
  - abbr: AAMAS
    pages: 972–981
    authors: Keisuke Okumura, Ryo Yonetani, Mai Nishimura, Asako Kanezaki
    blog:
      en: https://medium.com/sinicx/ctrms-learning-to-construct-cooperative-timed-roadmaps-for-multi-agent-path-planning-in-continuous-196e4b75f501
      ja: https://medium.com/sinicx-ja/%E3%83%87%E3%83%BC%E3%82%BF%E9%A7%86%E5%8B%95%E5%9E%8B%E3%83%9E%E3%83%AB%E3%83%81%E3%82%A8%E3%83%BC%E3%82%B8%E3%82%A7%E3%83%B3%E3%83%88%E7%B5%8C%E8%B7%AF%E8%A8%88%E7%94%BB%E3%81%AB%E9%96%A2%E3%81%99%E3%82%8B%E7%A0%94%E7%A9%B6%E3%81%8Caamas-2022%E3%81%AB%E6%8E%A1%E6%8A%9E%E3%81%95%E3%82%8C%E3%81%BE%E3%81%97%E3%81%9F-eb70163060e8
    doi: https://dl.acm.org/doi/10.5555/3535850.3535959
    github: https://github.com/omron-sinicx/ctrm/
    image: ctrm
    month: 5
    others:
      en: "Acceptance Rate: 166/629=26.4%"
      ja: "採択率: 166/629=26.4%"
    paperUrl: https://arxiv.org/abs/2201.09467
    projectPage: https://omron-sinicx.github.io/ctrm/
    speakerdeck: https://speakerdeck.com/osx/ctrms-learning-to-construct-cooperative-timed-roadmaps-for-multi-agent-path-planning-in-continuous-spaces-aamas-22
    title: "CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent
      Path Planning in Continuous Spaces

      "
    year: 2022
    kind: reviewedProceeding
  - abbr: IROS
    authors: Keisuke Okumura, Yasumasa Tamura, Xavier Défago
    doi: https://doi.org/10.1109/IROS51168.2021.9636071
    github: https://github.com/Kei18/mapf-IR/
    image: iterative-refinement
    month: 9
    others:
      en: "Acceptance Rate: x/2801=45%"
      ja: "採択率: x/2801=45%"
    paperUrl: https://arxiv.org/abs/2102.12331
    projectPage: https://kei18.github.io/mapf-IR/
    speakerdeck: https://speakerdeck.com/kei18/iterative-refinement-for-real-time-multi-robot-path-planning
    title: Iterative Refinement for Real-Time Multi-Robot Path Planning
    youtube: https://youtu.be/A6M2G6mhhxM
    year: 2021
    pages: 9690-9697
    kind: reviewedProceeding
  - abbr: ICRA
    authors: Shota Kameyama, Keisuke Okumura, Yasumasa Tamura, Xavier Défago
    doi: https://doi.org/10.1109/ICRA48506.2021.9561111
    image: afada
    month: 6
    others:
      en: "Acceptance Rate: 1946/4056=48.0%"
      ja: "採択率: 1946/4005=48.0%"
    paperUrl: https://arxiv.org/abs/2102.12748
    projectPage: https://dfg-lab.github.io/afada/
    speakerdeck: https://speakerdeck.com/kei18/active-modular-environment-for-robot-navigation
    title: Active Modular Environment for Robot Navigation
    vimeo: https://vimeo.com/516571573
    year: 2021
    pages: 8636-8642
    kind: reviewedProceeding
  - abbr: AAAI
    authors: Keisuke Okumura, Yasumasa Tamura, Xavier Défago
    doi: "https://doi.org/10.1609/aaai.v35i13.17347

      "
    github: https://github.com/Kei18/time-independent-planning
    image: time-independent-planning
    month: 5
    others:
      en: "Acceptance Rate: 1692/7911=21.3%"
      ja: "採択率: 1692/7911=21.3%"
    paperUrl: https://ojs.aaai.org/index.php/AAAI/article/view/17347
    projectPage: https://kei18.github.io/time-independent-planning/
    speakerdeck: https://speakerdeck.com/kei18/time-independent-planning-for-multiple-moving-agents
    title: Time-Independent Planning for Multiple Moving Agents
    year: 2021
    pages: 11299-11307
    kind: reviewedProceeding
  - abbr: IJCAI
    authors: Keisuke Okumura, Manao Machida, Xavier Défago, Yasumasa Tamura
    date: 10-16
    doi: https://doi.org/10.24963/ijcai.2019/76
    github: https://github.com/Kei18/pibt
    image: pibt
    month: 8
    others:
      en: "Acceptance Rate: 850/4752=17.9%"
      ja: "採択率: 850/4752=17.9%"
    pages: 535-542
    place: Macao, China
    projectPage: https://kei18.github.io/pibt
    speakerdeck: https://speakerdeck.com/kei18/priority-inheritance-with-backtracking-for-iterative-multi-agent-path-finding
    title: Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding
    year: 2019
    kind: reviewedProceeding
  - abbr: iCAST
    authors: Keisuke Okumura, Yasumasa Tamura, Xavier Défago
    date: 10-16
    doi: https://doi.org/10.1109/ICAwST.2018.8517225
    image: amoeba
    month: 9
    pages: 191-195
    place: Fukuoka, Japan
    speakerdeck: https://speakerdeck.com/kei18/amoeba-exploration-coordinated-exploration-with-distributed-robots
    title: "Amoeba Exploration: Coordinated Exploration with Distributed Robots"
    year: 2018
    kind: reviewedProceeding
  - abbr: VTC
    authors: Mai Hirata, Manabu Tsukada, Keisuke Okumura, Yasumasa Tamura, Hideya Ochiai,
      Xavier Défago
    doi: https://doi.org/10.1109/VTC2021-Fall52928.2021.9625324
    image: coordinated_path
    month: 9
    paperUrl: https://arxiv.org/abs/2108.04629
    title: Roadside-assisted Cooperative Planning using Future Path Sharing for Autonomous
      Driving
    year: 2021
    pages: 1-7
    kind: reviewedProceedingMinor
  - abbr: WoMAPF
    authors: Keisuke Okumura, Yasumasa Tamura, Xavier Défago
    github: https://github.com/Kei18/pibt
    image: winpibt
    month: 1
    paperUrl: https://arxiv.org/abs/1905.10149
    projectPage: https://kei18.github.io/pibt/
    speakerdeck: https://speakerdeck.com/kei18/winpibt-extended-prioritized-algorithm-for-iterative-multi-agent-path-finding
    title: "winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent Path Finding"
    year: 2021
    pages: 1-9
    kind: reviewedWorkshop
  - abbr: JRM
    authors: Shota Yamamoto, Ryusei Matsumoto, Yoko Sasaki, Keisuke Okumura
    image: 100mouse
    month: 12
    paperUrl: https://www.fujipress.jp/jrm/rb/robot003700061545/
    title: "100-Mouse System: Scalable Multi-Robot Testbed with State Management User
      Interface

      "
    year: 2025
    pages: 1545-1556
    doi: https://doi.org/10.20965/jrm.2025.p1545
    kind: journal
  - abbr: RA-L
    authors: Takuro Kato, Keisuke Okumura, Yoko Sasaki, Naoya Yokomachi
    image: cmpp
    month: 8
    paperUrl: https://arxiv.org/abs/2508.05253
    title: "Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation
      in Dense Environments

      "
    year: 2025
    pages: 9742-9749
    doi: https://doi.org/10.1109/LRA.2025.3597871
    kind: journal
  - pages: 1-20
    authors: Jean-Marc Alkazzi, Keisuke Okumura
    book: IEEE Access
    image: mapf-ml-review
    month: 4
    doi: https://doi.org/10.1109/access.2024.3392305
    title: "A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path
      Finding

      "
    year: 2024
    others: "IF(2022)=3.9 h-index(24)=204

      "
    kind: journal
  - abbr: AIJ
    selected: true
    pages: 103946(1-27)
    authors: Keisuke Okumura, Xavier Défago
    github: https://github.com/Kei18/tswap/
    image: tswap2
    month: 5
    doi: https://doi.org/10.1016/j.artint.2023.103946
    others:
      en: |
        IF(22-23)=14.4, h-index(22)=161<br/>
        <span class="text-danger">Invited from ICAPS-22 following the Best Student Paper Award</span>
      ja: |
        IF(22-23)=14.4, h-index(22)=161, ICAPS-22 から招待されたもの
    paperUrl: https://www.sciencedirect.com/science/article/pii/S0004370223000929
    projectPage: https://kei18.github.io/tswap/
    speakerdeck: https://speakerdeck.com/kei18/solving-simultaneous-target-assignment-and-path-planning-efficiently-with-time-independent-execution
    title: "Solving Simultaneous Target Assignment and Path Planning Efficiently with
      Time-Independent Execution

      "
    youtube: https://youtu.be/NkU8r2u8-1c
    year: 2023
    kind: journal
  - abbr: T-RO
    selected: true
    authors: Keisuke Okumura, François Bonnet, Yasumasa Tamura, Xavier Défago
    doi: https://doi.org/10.1109/tro.2023.3258690
    github: https://github.com/Kei18/otimapp/
    image: otimapp2
    month: 4
    others:
      en: IF(22-23)=7.8, h-index(23)=177, extended from IJCAI-22
      ja: IF(22-23)=7.8, h-index(23)=177, IJCAI-22 を拡張したもの
    paperUrl: https://ieeexplore.ieee.org/document/10092929
    projectPage: https://kei18.github.io/otimapp/
    title: Offline Time-Independent Multiagent Path Planning
    youtube: https://youtu.be/-p59f3epO1M
    year: 2023
    pages: 2720-2737
    kind: journal
  - abbr: AIJ
    selected: true
    authors: Keisuke Okumura, Manao Machida, Xavier Défago, Yasumasa Tamura
    doi: https://doi.org/10.1016/j.artint.2022.103752
    github: https://github.com/Kei18/pibt2/
    image: pibt2
    month: 6
    others:
      en: IF(21-22)=14.05, h-index(22)=155, extended from IJCAI-19
      ja: IF(21-22)=14.05, h-index(22)=155, IJCAI-19 を拡張したもの
    paperUrl: https://www.sciencedirect.com/science/article/pii/S0004370222000923
    projectPage: https://kei18.github.io/pibt2/
    title: Priority Inheritance with Backtracking for Iterative Multi-agent Path Finding
    youtube: https://www.youtube.com/watch?v=8Yrwd0t0NEw
    year: 2022
    pages: 103752(1-22)
    kind: journal
  - authors: Keisuke Okumura, Hiroki Ora, Yoshihiro Miyake
    book: Frontiers in Robotics and AI - Virtual Environments
    date: 15
    doi: https://doi.org/10.3389/frobt.2020.00049
    image: OHI
    month: 4
    title: Investigating the Hand Ownership Illusion With Two Views Merged in
    year: 2020
    others: IF(19-20)=2.98
    pages: 1-9
    kind: journal
  - authors: Ajay Shankar, Keisuke Okumura, Amanda Prorok
    book: arXiv preprint
    image: lf
    month: 7
    projectPage: https://proroklab.github.io/lf
    paperUrl: https://arxiv.org/abs/2507.11464
    title: "LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control

      "
    year: 2025
    pages: 1-9
    github: https://github.com/proroklab/lf
    kind: preprint
    others: |
      presented at WoMAPF-25
  - authors: Heedo Woo, Kazi R. I. Sanim, Keisuke Okumura, Guang Yang, Ajay Shankar,
      Amanda Prorok
    book: Technical Report
    image: sanity
    month: 7
    paperUrl: https://openreview.net/forum?id=i5dKOANPZZ
    title: "Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments

      "
    year: 2025
    pages: 1-5
    others: presented at CoRL-25's Workshop
    kind: preprint
  - authors: Keisuke Okumura
    book: arXiv preprint
    image: lacas
    month: 8
    paperUrl: https://arxiv.org/abs/2408.15443
    title: Pathfinding with Lazy Successor Generation
    year: 2024
    pages: 1-14
    kind: preprint
  - authors: 奥村 圭祐
    book: コンピュータビジョン最前線 Spring 2025
    image: cvbook2025
    month: 3
    projectPage: https://www.kyoritsu-pub.co.jp/book/b10123411.html
    title: イマドキノマルチエージェント経路計画 ―大規模オートメーションへの挑戦!―
    year: 2025
    kind: book
  - authors: Keisuke Okumura
    book: Ph.D. Dissertation, Tokyo Institute of Technology
    image: phd
    month: 3
    paperUrl:
      "https://t2r2.star.titech.ac.jp/cgi-bin/publicationinfo.cgi?lv=en&q_publication_content_number=CTT100886180

      "
    projectPage: https://kei18.github.io/phd-dissertation
    title: Planning, Execution, Representation, and their Integration for Multiple Moving
      Agents
    year: 2023
    pages: 1-278
    blog: https://doi.org/10.11517/jjsai.39.1_50
    others:
      en: '<span class="text-danger">Ph.D. Dissertation Award (Seiichi Tejima Research
        Award), Tokyo Institute of Technology</span>

        '
      ja: '<span class="text-danger">東京工業大学 手島精一記念研究賞 (博士論文賞)</span>

        '
    kind: dissertation
  - title:
      en: JP,2021-106321,A
      ja: 管理システム及び管理方法 (特開2021-106321)
    kind: patent
